import { PortfolioHeader } from './PortfolioHeader';
import { PortfolioLoading } from './PortfolioLoading';
import { PortfolioEmptyState } from './PortfolioEmptyState';
import { PortfolioProps } from './types/asset.types';
import { useSession } from '@/contexts/LitSessionProvider';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { useState } from 'react';
import Loading from '../shared/Loading';
import { useLocalStorage } from 'usehooks-ts';
import { PortfolioAssetItem } from './PortfolioAssetItem';
import { X } from 'lucide-react';
export type TAssetModes = 'Balance' | 'Returns (24hr)' | 'Gains (24hr)' | 'Allocation';
export default function AssetsPortfolio({
  showBreakDown,
  isSwap
}: PortfolioProps) {
  const {
    PKP
  } = useSession();
  const [linkClickedLoading, setLinkClickedLoading] = useState(false);
  const {
    data: assetData,
    isLoading: assetDataIsLoading
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const [assetMode, setAssetMode] = useLocalStorage<TAssetModes>('genius-assets-portfolio-mode', 'Balance');
  const goToNextAssetMode = () => {
    if (assetMode === 'Balance') {
      setAssetMode('Returns (24hr)');
    } else if (assetMode === 'Returns (24hr)') {
      setAssetMode('Gains (24hr)');
    } else if (assetMode === 'Gains (24hr)') {
      setAssetMode('Allocation');
    } else if (assetMode === 'Allocation') {
      setAssetMode('Balance');
    }
  };
  const [selectedNetwork, setSelectedNetwork] = useState({
    name: 'All Networks',
    value: `$${assetData?.totalUsdValue?.toLocaleString()}`,
    logo: '/static/genius.png'
  });
  const [showCashModal, setShowCashModal] = useState(false);
  const filteredBalances = (selectedNetwork.name === 'All Networks' ? assetData?.balances : assetData?.balancesByChain?.find(chain => chain.networkName === selectedNetwork.name)?.balances || [])?.filter((x: any) => x?.contract_address).filter(x => x.usd_value > 0).sort((a: any, b: any) => b.usd_value - a.usd_value);
  return <>
      <PortfolioHeader showCashModal={showCashModal} setShowCashModal={setShowCashModal} assetMode={assetMode} gotoNextAssetMode={goToNextAssetMode} isSwap={isSwap} assetData={assetData} selectedNetwork={selectedNetwork} setSelectedNetwork={setSelectedNetwork} data-sentry-element="PortfolioHeader" data-sentry-source-file="AssetsPortfolio.tsx" />

      <div className={`w-full text-genius-cream overflow-y-auto bg-genius-indigo pb-32 ${showBreakDown ? '' : '-mb-[14vh]'}`}>
        {assetDataIsLoading ? <PortfolioLoading /> : linkClickedLoading ? <div className='h-[550px]  flex items-center justify-center'>
            <Loading />
          </div> : filteredBalances.length === 0 ? <PortfolioEmptyState /> : <>
            {filteredBalances.map((assetItem: any, index: number) => showCashModal ? (assetItem?.contract_ticker_symbol === "USDC" || assetItem.contract_ticker_symbol === 'USDT') && <PortfolioAssetItem assetMode={assetMode} key={index} isSwap={isSwap} setLinkClickedLoading={setLinkClickedLoading} assetItem={assetItem} assetData={assetData} /> : <PortfolioAssetItem assetMode={assetMode} key={index} isSwap={isSwap} setLinkClickedLoading={setLinkClickedLoading} assetItem={assetItem} assetData={assetData} />)}
          </>}
      </div>
    </>;
}